import React from "react";

// Panneau latéral de la version web (desktop) : illustration, puis la borne ou
// le récapitulatif de la session.
export function StationSidePanel({ panel, className = "" }) {
  return (
    <aside className={`w-[400px] shrink-0 overflow-hidden rounded-2xl border border-qv-line bg-white ${className}`}>
      {panel.image && (
        <div className="h-60 bg-qv-brand-50 flex items-center justify-center">
          <img src="/charging-car.png" alt="" className="h-[190px]" />
        </div>
      )}
      <div className="flex flex-col gap-[18px] px-8 py-7">
        <h2 className="text-lg leading-[26px] font-bold">{panel.title}</h2>
        {panel.rows.map((row) => (
          <div key={`${row.label}-${row.value}`} className="flex items-center gap-3.5">
            <span className="h-11 w-11 shrink-0 rounded-xl bg-qv-brand-50 flex items-center justify-center">
              <img src={row.icon} alt="" className="h-6 w-6" />
            </span>
            <div className="min-w-0">
              <div className="text-xs font-semibold uppercase tracking-[.08em] text-qv-muted">{row.label}</div>
              <div className="mt-0.5 text-[15px] font-semibold break-words">{row.value}</div>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}

// Même contenu en bandeau au-dessus de la carte, sur tablette.
export function StationBand({ panel, className = "" }) {
  return (
    <aside
      aria-label={panel.title}
      className={`w-[560px] max-w-full flex-wrap gap-x-6 gap-y-4 rounded-2xl border border-qv-line bg-white px-5 py-4 ${className}`}
    >
      {panel.rows.map((row) => (
        <div key={`${row.label}-${row.value}`} className="flex min-w-0 flex-[1_1_140px] items-center gap-2.5">
          <span className="h-9 w-9 shrink-0 rounded-[10px] bg-qv-brand-50 flex items-center justify-center">
            <img src={row.icon} alt="" className="h-5 w-5" />
          </span>
          <div className="min-w-0">
            <div className="text-[11px] font-semibold uppercase tracking-[.08em] text-qv-muted">{row.label}</div>
            <div className="mt-0.5 text-[13px] font-semibold leading-[18px]">{row.value}</div>
          </div>
        </div>
      ))}
    </aside>
  );
}
